/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

              import * as CustomScalars from '@/scalars'
            
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: DateString; output: DateString; }
  FieldSet: { input: string; output: string; }
  Time: { input: DateString; output: DateString; }
  Uint: { input: number; output: number; }
  Void: { input: CustomScalars.Void; output: CustomScalars.Void; }
  _Any: { input: string; output: string; }
  federation__Policy: { input: string; output: string; }
  federation__Scope: { input: string; output: string; }
};

export type AnswerEnqueteInput = {
  answerItems: Array<AnswerEnqueteInputAnswerItem>;
  enqueteGUID: Scalars['ID']['input'];
};

export type AnswerEnqueteInputAnswerItem = {
  questionGUID: Scalars['ID']['input'];
  valueMultipleSelectOptionGUIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  valueSelectOptionGUID?: InputMaybe<Scalars['String']['input']>;
  valueString?: InputMaybe<Scalars['String']['input']>;
  valueText?: InputMaybe<Scalars['String']['input']>;
};

export type AnswerEnquetePayload = {
  __typename?: 'AnswerEnquetePayload';
  void: Scalars['Void']['output'];
};

export type CreateLineClickLinkLogInput = {
  idToken: Scalars['String']['input'];
  liffVersion: Scalars['String']['input'];
  lineActivationProviderId: Scalars['ID']['input'];
  lineVersion?: InputMaybe<Scalars['String']['input']>;
  os: Scalars['String']['input'];
  redirectURLId: Scalars['ID']['input'];
};

export type CreateLineClickLinkLogPayload = {
  __typename?: 'CreateLineClickLinkLogPayload';
  redirectURL: Scalars['String']['output'];
};

export type Enquete = {
  __typename?: 'Enquete';
  guid: Scalars['ID']['output'];
  questions: Array<EnqueteQuestion>;
  title: Scalars['String']['output'];
};

export enum EnqueteAnswerDataType {
  MultipleSelect = 'MULTIPLE_SELECT',
  Select = 'SELECT',
  String = 'STRING',
  Text = 'TEXT'
}

export type EnquetePayload = {
  __typename?: 'EnquetePayload';
  enquete: Enquete;
  isAlreadyAnswered: Scalars['Boolean']['output'];
};

export type EnqueteQuestion = {
  __typename?: 'EnqueteQuestion';
  form: EnqueteQuestionForm;
  guid: Scalars['ID']['output'];
  isAnswerRequired: Scalars['Boolean']['output'];
  questionText: Scalars['String']['output'];
};

export type EnqueteQuestionForm = EnqueteQuestionFormCheckbox | EnqueteQuestionFormInputText | EnqueteQuestionFormRadio | EnqueteQuestionFormSelect | EnqueteQuestionFormTextarea;

export type EnqueteQuestionFormCheckbox = {
  __typename?: 'EnqueteQuestionFormCheckbox';
  answerDataType: EnqueteAnswerDataType;
  options: Array<EnqueteQuestionSelectOption>;
};

export type EnqueteQuestionFormInputText = {
  __typename?: 'EnqueteQuestionFormInputText';
  answerDataType: EnqueteAnswerDataType;
};

export type EnqueteQuestionFormRadio = {
  __typename?: 'EnqueteQuestionFormRadio';
  answerDataType: EnqueteAnswerDataType;
  options: Array<EnqueteQuestionSelectOption>;
};

export type EnqueteQuestionFormSelect = {
  __typename?: 'EnqueteQuestionFormSelect';
  answerDataType: EnqueteAnswerDataType;
  options: Array<EnqueteQuestionSelectOption>;
};

export type EnqueteQuestionFormTextarea = {
  __typename?: 'EnqueteQuestionFormTextarea';
  answerDataType: EnqueteAnswerDataType;
};

export type EnqueteQuestionSelectOption = {
  __typename?: 'EnqueteQuestionSelectOption';
  guid: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type Error = {
  message: Scalars['String']['output'];
};

export type IssueApiTokenInput = {
  lineActivationProviderId: Scalars['ID']['input'];
  lineToken: Scalars['String']['input'];
};

export type IssueApiTokenPayload = IssueApiTokenSuccess;

export type IssueApiTokenSuccess = {
  __typename?: 'IssueAPITokenSuccess';
  apiToken: Scalars['String']['output'];
};

export type LineActivationProviderLiffAppConfig = {
  __typename?: 'LINEActivationProviderLiffAppConfig';
  clientId: Scalars['String']['output'];
  liffId: Scalars['String']['output'];
  loginRedirectUri: Scalars['String']['output'];
};

export type LineLoginLinkUser = {
  __typename?: 'LINELoginLinkUser';
  okanentClientUserGUID: Scalars['String']['output'];
  userID: Scalars['ID']['output'];
  userRegistrationInflowSourceDefinitionGUID?: Maybe<Scalars['String']['output']>;
};

export type LinkLineActivationRawIdInput = {
  lineActivationProviderId: Scalars['ID']['input'];
  lineToken: Scalars['String']['input'];
  rawId: Scalars['String']['input'];
};

export type LinkLineActivationRawIdPayload = {
  __typename?: 'LinkLineActivationRawIdPayload';
  void: Scalars['Void']['output'];
};

export type LinkLineActivationTokenInput = {
  lineToken: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type LinkLineActivationTokenPayload = {
  __typename?: 'LinkLineActivationTokenPayload';
  void: Scalars['Void']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  answerEnquete: AnswerEnquetePayload;
  createLineClickLinkLog: CreateLineClickLinkLogPayload;
  issueAPIToken: IssueApiTokenPayload;
  linkLineActivationRawId: LinkLineActivationRawIdPayload;
  linkLineActivationToken: LinkLineActivationTokenPayload;
  registerInflowSource: RegisterInflowSourcePayload;
};


export type MutationAnswerEnqueteArgs = {
  input: AnswerEnqueteInput;
};


export type MutationCreateLineClickLinkLogArgs = {
  input: CreateLineClickLinkLogInput;
};


export type MutationIssueApiTokenArgs = {
  input: IssueApiTokenInput;
};


export type MutationLinkLineActivationRawIdArgs = {
  input: LinkLineActivationRawIdInput;
};


export type MutationLinkLineActivationTokenArgs = {
  input: LinkLineActivationTokenInput;
};


export type MutationRegisterInflowSourceArgs = {
  input: RegisterInflowSourceInput;
};

export type Query = {
  __typename?: 'Query';
  _service: _Service;
  enquete: EnquetePayload;
  lineActivationProviderLiffAppConfigByProviderId?: Maybe<LineActivationProviderLiffAppConfig>;
  lineLoginLinkUser?: Maybe<LineLoginLinkUser>;
};


export type QueryEnqueteArgs = {
  guid: Scalars['ID']['input'];
};


export type QueryLineActivationProviderLiffAppConfigByProviderIdArgs = {
  providerId: Scalars['ID']['input'];
};


export type QueryLineLoginLinkUserArgs = {
  lineToken: Scalars['String']['input'];
  providerId: Scalars['ID']['input'];
};

export type RegisterInflowSourceInput = {
  idToken: Scalars['String']['input'];
  inflowSourceGUID: Scalars['ID']['input'];
  lineActivationProviderId: Scalars['ID']['input'];
};

export type RegisterInflowSourcePayload = {
  __typename?: 'RegisterInflowSourcePayload';
  lineFollowURL: Scalars['String']['output'];
};

export type UnknownError = Error & {
  __typename?: 'UnknownError';
  message: Scalars['String']['output'];
};

export type _Service = {
  __typename?: '_Service';
  sdl?: Maybe<Scalars['String']['output']>;
};

export type EnqueteFormEnqueteFragment = { __typename?: 'Enquete', guid: string, title: string, questions: Array<{ __typename?: 'EnqueteQuestion', guid: string, questionText: string, isAnswerRequired: boolean, form: { __typename: 'EnqueteQuestionFormCheckbox', answerDataType: EnqueteAnswerDataType, options: Array<{ __typename?: 'EnqueteQuestionSelectOption', guid: string, label: string }> } | { __typename: 'EnqueteQuestionFormInputText', answerDataType: EnqueteAnswerDataType } | { __typename: 'EnqueteQuestionFormRadio', answerDataType: EnqueteAnswerDataType, options: Array<{ __typename?: 'EnqueteQuestionSelectOption', guid: string, label: string }> } | { __typename: 'EnqueteQuestionFormSelect', answerDataType: EnqueteAnswerDataType, options: Array<{ __typename?: 'EnqueteQuestionSelectOption', guid: string, label: string }> } | { __typename: 'EnqueteQuestionFormTextarea', answerDataType: EnqueteAnswerDataType } }> } & { ' $fragmentName'?: 'EnqueteFormEnqueteFragment' };

export type AnswerEnqueteMutationVariables = Exact<{
  input: AnswerEnqueteInput;
}>;


export type AnswerEnqueteMutation = { __typename?: 'Mutation', answerEnquete: { __typename?: 'AnswerEnquetePayload', void: CustomScalars.Void } };

export type GetEnqueteQueryVariables = Exact<{
  guid: Scalars['ID']['input'];
}>;


export type GetEnqueteQuery = { __typename?: 'Query', enquete: { __typename?: 'EnquetePayload', isAlreadyAnswered: boolean, enquete: (
      { __typename?: 'Enquete', title: string }
      & { ' $fragmentRefs'?: { 'EnqueteFormEnqueteFragment': EnqueteFormEnqueteFragment } }
    ) } };

export type LoginGuardQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
}>;


export type LoginGuardQuery = { __typename?: 'Query', lineActivationProviderLiffAppConfigByProviderId?: { __typename?: 'LINEActivationProviderLiffAppConfig', clientId: string } | null };

export type RegisterInflowSourceMutationVariables = Exact<{
  input: RegisterInflowSourceInput;
}>;


export type RegisterInflowSourceMutation = { __typename?: 'Mutation', registerInflowSource: { __typename?: 'RegisterInflowSourcePayload', lineFollowURL: string } };

export type ProvidersLineActivationProviderIdLoginLinkIndexPageQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
}>;


export type ProvidersLineActivationProviderIdLoginLinkIndexPageQuery = { __typename?: 'Query', lineActivationProviderLiffAppConfigByProviderId?: { __typename?: 'LINEActivationProviderLiffAppConfig', clientId: string, loginRedirectUri: string } | null };

export type LineLoginLinkUserQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
  lineToken: Scalars['String']['input'];
}>;


export type LineLoginLinkUserQuery = { __typename?: 'Query', lineLoginLinkUser?: { __typename?: 'LINELoginLinkUser', userID: string, okanentClientUserGUID: string, userRegistrationInflowSourceDefinitionGUID?: string | null } | null };

export type LinkLineActivationRawIdMutationVariables = Exact<{
  input: LinkLineActivationRawIdInput;
}>;


export type LinkLineActivationRawIdMutation = { __typename?: 'Mutation', linkLineActivationRawId: { __typename?: 'LinkLineActivationRawIdPayload', void: CustomScalars.Void } };

export type LinkLineActivationTokenMutationVariables = Exact<{
  input: LinkLineActivationTokenInput;
}>;


export type LinkLineActivationTokenMutation = { __typename?: 'Mutation', linkLineActivationToken: { __typename?: 'LinkLineActivationTokenPayload', void: CustomScalars.Void } };

export type CreateLineClickLinkLogMutationVariables = Exact<{
  input: CreateLineClickLinkLogInput;
}>;


export type CreateLineClickLinkLogMutation = { __typename?: 'Mutation', createLineClickLinkLog: { __typename?: 'CreateLineClickLinkLogPayload', redirectURL: string } };

export type IssueApiTokenMutationVariables = Exact<{
  input: IssueApiTokenInput;
}>;


export type IssueApiTokenMutation = { __typename?: 'Mutation', issueAPIToken: { __typename: 'IssueAPITokenSuccess', apiToken: string } };

export type LiffPluginQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
}>;


export type LiffPluginQuery = { __typename?: 'Query', lineActivationProviderLiffAppConfigByProviderId?: { __typename?: 'LINEActivationProviderLiffAppConfig', clientId: string, liffId: string } | null };

export const EnqueteFormEnqueteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnqueteFormEnquete"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Enquete"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"questionText"}},{"kind":"Field","name":{"kind":"Name","value":"isAnswerRequired"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnqueteQuestionFormInputText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerDataType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnqueteQuestionFormTextarea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerDataType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnqueteQuestionFormRadio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerDataType"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnqueteQuestionFormSelect"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerDataType"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnqueteQuestionFormCheckbox"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerDataType"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<EnqueteFormEnqueteFragment, unknown>;
export const AnswerEnqueteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AnswerEnquete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnswerEnqueteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerEnquete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"void"}}]}}]}}]} as unknown as DocumentNode<AnswerEnqueteMutation, AnswerEnqueteMutationVariables>;
export const GetEnqueteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEnquete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"guid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enquete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"guid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"guid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isAlreadyAnswered"}},{"kind":"Field","name":{"kind":"Name","value":"enquete"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnqueteFormEnquete"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnqueteFormEnquete"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Enquete"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"questions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"questionText"}},{"kind":"Field","name":{"kind":"Name","value":"isAnswerRequired"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnqueteQuestionFormInputText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerDataType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnqueteQuestionFormTextarea"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerDataType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnqueteQuestionFormRadio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerDataType"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnqueteQuestionFormSelect"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerDataType"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnqueteQuestionFormCheckbox"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerDataType"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"guid"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEnqueteQuery, GetEnqueteQueryVariables>;
export const LoginGuardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"loginGuard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineActivationProviderLiffAppConfigByProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}}]}}]}}]} as unknown as DocumentNode<LoginGuardQuery, LoginGuardQueryVariables>;
export const RegisterInflowSourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"registerInflowSource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterInflowSourceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"registerInflowSource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineFollowURL"}}]}}]}}]} as unknown as DocumentNode<RegisterInflowSourceMutation, RegisterInflowSourceMutationVariables>;
export const ProvidersLineActivationProviderIdLoginLinkIndexPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"providersLineActivationProviderIdLoginLinkIndexPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineActivationProviderLiffAppConfigByProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"loginRedirectUri"}}]}}]}}]} as unknown as DocumentNode<ProvidersLineActivationProviderIdLoginLinkIndexPageQuery, ProvidersLineActivationProviderIdLoginLinkIndexPageQueryVariables>;
export const LineLoginLinkUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"lineLoginLinkUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineLoginLinkUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"lineToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"okanentClientUserGUID"}},{"kind":"Field","name":{"kind":"Name","value":"userRegistrationInflowSourceDefinitionGUID"}}]}}]}}]} as unknown as DocumentNode<LineLoginLinkUserQuery, LineLoginLinkUserQueryVariables>;
export const LinkLineActivationRawIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"linkLineActivationRawId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LinkLineActivationRawIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkLineActivationRawId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"void"}}]}}]}}]} as unknown as DocumentNode<LinkLineActivationRawIdMutation, LinkLineActivationRawIdMutationVariables>;
export const LinkLineActivationTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"linkLineActivationToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LinkLineActivationTokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkLineActivationToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"void"}}]}}]}}]} as unknown as DocumentNode<LinkLineActivationTokenMutation, LinkLineActivationTokenMutationVariables>;
export const CreateLineClickLinkLogDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createLineClickLinkLog"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLineClickLinkLogInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLineClickLinkLog"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redirectURL"}}]}}]}}]} as unknown as DocumentNode<CreateLineClickLinkLogMutation, CreateLineClickLinkLogMutationVariables>;
export const IssueApiTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"issueAPIToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IssueAPITokenInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueAPIToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IssueAPITokenSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiToken"}}]}}]}}]}}]} as unknown as DocumentNode<IssueApiTokenMutation, IssueApiTokenMutationVariables>;
export const LiffPluginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"liffPlugin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineActivationProviderLiffAppConfigByProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"liffId"}}]}}]}}]} as unknown as DocumentNode<LiffPluginQuery, LiffPluginQueryVariables>;